<template>
  <div class="skeleton-container" :style="skeletonStyle"></div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'n-skeleton'
})
export default class NSkeleton extends Vue {
  @Prop({ type: String, validator: (prop: string) => ['s', 'm', 'l', 'xl'].includes(prop), default: 'm' })
  private size!: string

  get skeletonStyle() {
    switch (this.size) {
      case 's':
        return 'height: 16px'
      case 'm':
        return 'height: 32px'
      case 'l':
        return 'height: 64px'
      case 'xl':
        return 'height: 100px'
      default:
        return ''
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles' as *;

.skeleton-container {
  background-color: $notch-color-neutral-grey-000;
  background: linear-gradient(
    90deg,
    $notch-color-neutral-sand-100 25%,
    rgba($notch-color-neutral-sand-100, 0.3) 50%,
    $notch-color-neutral-sand-100 75%
  );
  background-size: 400% 100%;
  width: 100%;
  border-radius: $notch-radius-2x;
  animation: skeleton-loading-notch 1.5s infinite;
}

@keyframes skeleton-loading-notch {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
